<template>
  <div class="step">
    <div class="step-wrapper">
      <h2>Анамнез и жалобы</h2>
      <p class="description">Пациентка У., 53 года, домохозяйка.</p>
      <div class="items">
        <div v-for="(item, index) in items" class="item" :key="item.title">
          <div class="item-title" @click="item.opened = !item.opened">
            <svg width="17" height="15" viewBox="0 0 17 15"  stroke="#004C97" stroke-width="1" fill="none">
              <path d="M3.5,7.5 L13.5,7.5" id="Path" stroke-width="2"></path>
              <path v-if="!item.opened" d="M8.5,2.5 L8.5,12.5" id="Path" stroke-width="2"></path>
              <polyline points="3.5 0.5 0.5 0.5 0.5 14.5 3.5 14.5"></polyline>
              <polyline points="13.5 0.5 16.5 0.5 16.5 14.5 13.5 14.5"></polyline>
            </svg>
            <hand v-if="index === 0 && showHand" :right="true" />
            {{ item.title }}<template v-if="item.opened">:</template>
          </div>
          <div class="item-description" :class="{ 'item-description--opened': item.opened }" v-html="item.description" />
        </div>
      </div>
    </div>
    <img class="cover" src="@/assets/step-anamnesis.jpg">
    <div class="step-next" @click="$emit('step', 'clarification')">
      <span>Уточнить анамнез</span>
      <svg viewBox="0 0 27 12" width="27" height="12">
        <path fill="#FFF" fill-rule="evenodd" d="M.01 5h17.14C15.83 3.07 15.17 1.8 15.1.09c3.01 2.96 6.93 4.5 11.67 5.95C22.03 7.43 18.29 9.12 15.1 12c.2-1.86.75-2.99 2.1-5.04H0V5z"/>
      </svg>
    </div>
  </div>
</template>

<script>
import Hand from './hand'

export default {
  components: {
    Hand
  },
  data () {
    return {
      items: [
        {
          opened: false,
          title: 'Жалобы',
          description: 'головокружение и неустойчивость при ходьбе.'
        },
        {
          opened: false,
          title: 'Хронические заболевания',
          description: 'варикозная болезнь.'
        },
        {
          opened: false,
          title: 'Анамнез',
          description: `10 дней назад среди полного здоровья внезапно возникло вращательное головокружение, которое значительно усилилось в&nbsp;течение 6 часов, появились тошнота и рвота, не могла самостоятельно ходить. Была вызвана бригада СМП, была госпитализирована, проходила стационарное лечение в течение недели <b>с&nbsp;диагнозом «транзиторная ишемическая атака»</b>.<br><br>
          В стационаре вращательное головокружение и вегетативные симптомы купировались в течение 2 дней, головокружение практически отсутствует в покое, однако сохраняется неустойчивость и шаткость при ходьбе.`
        }
      ]
    }
  },
  computed: {
    showHand () {
      return !this.items.some(
        el => el.opened === true
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.step {
  position: relative;
  display: flex;
  align-items: center;

  @include media-down(md) {
    flex-direction: column;
  }
}
.description {
  font-size: 16px;
  color: #252628;
  margin: 0;
  padding: 0;
  padding-right: 25%;
}
h2 {
  padding-right: 25%;
}
.items {
  padding: 0 360px 0 0;

  @include media-down(lg) {
    padding: 0 280px 0 0;
  }
  @include media-down(md) {
    padding: 0;
    margin: 20px 0 0;
  }
}
.item {
  margin: 15px 0;
  line-height: 1.1;
  position: relative;

  .hand {
    top: 20px;
    right: 100%;
  }

  @include media-down(lg) {
    margin: 5px 0;
  }
  @include media-down(md) {
    margin: 15px 0;
  }

  &-title {
    color: #004c97;
    font-weight: bold;
    font-size: 16px;
    cursor: pointer;

    @include media-down(lg) {
      font-size: 14px;
    }

    svg {
      vertical-align: middle;
      margin: 0 3px 0 0;
    }
  }
  &-description {
    font-size: 16px;
    color: #252628;
    margin: 5px 0 0 22px;
    opacity: 0;
    transform: translate(100px, 0);

    @include media-down(md) {
      position: absolute;
    }

    @include media-down(lg) {
      font-size: 14px;
    }

    &--opened {
      opacity: 1;
      transition: all .3s;
      transform: translate(0, 0);

      @include media-down(md) {
        position: relative;
      }
    }
  }
}
.cover {
  position: absolute;
  border-radius: 50%;
  top: 0;
  right: 0;
  height: 100% !important;
  width: auto;

  @include media-down(md) {
    position: static;
    width: 25%;
    height: auto !important;
    order: -1;
    margin: 0 0 10px auto;
    position: absolute;
  }
}
</style>
